module.exports = __webpack_public_path__ + "img/logo11 - 副本.780ba79c.png";